import React, { createContext, useState, useEffect } from 'react';
import { getUsers, addUser, editUser, deleteUser } from '../../utils/api'; // Import mock API functions

export const UserContext = createContext();

const UserProvider = ({ children }) => {
  const [users, setUsers] = useState([]);

  // Fetch users on initial load
  useEffect(() => {
    const fetchUsers = async () => {
      const fetchedUsers = await getUsers(); // Simulate API call
      setUsers(fetchedUsers); // Set users from the mock API
    };
    fetchUsers();
  }, []); // Empty dependency array to run this effect only once

  // Function to add a new user
  const addUserHandler = async (user) => {
    const newUser = await addUser(user); // Call the mock API to add the user
    setUsers((prevUsers) => [...prevUsers, newUser]); // Update local state
  };

  // Function to edit an existing user
  const editUserHandler = async (id, updatedUser) => {
    const updated = await editUser(id, updatedUser); // Call the mock API to update the user
    if (updated) {
      setUsers((prevUsers) =>
        prevUsers.map((user) => (user.id === id ? updated : user)) // Update the user in the state
      );
    }
  };

  // Function to delete a user
  const deleteUserHandler = async (id) => {
    await deleteUser(id); // Call the mock API to delete the user
    setUsers((prevUsers) => prevUsers.filter((user) => user.id !== id)); // Update the state
  };

  return (
    <UserContext.Provider value={{ users, addUser: addUserHandler, editUser: editUserHandler, deleteUser: deleteUserHandler }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
